module.exports = __webpack_public_path__ + "static/media/rapidNaming-intro3.26b89542.mp3";